import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainApi } from '@/lib/api';
import { QUERY_KEYS, StoreType } from '@/lib/constants';
import { stanNotify } from '@/lib/stanNotify';

export function useHideFunnelPage(storeId: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (pageId: number) => {
            await mainApi.patch(`v1/stores/${storeId}/pages/${pageId}/hide`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FUNNELS, 'detail', storeId] });
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.STORE_DATA, StoreType.FUNNEL] });
        },
        onError: () => {
            stanNotify({
                type: 'error',
                title: 'Oops!',
                text: 'Failed to hide page. Please try again.',
                duration: 2000,
            });
        },
    });
}
